<button class="close modalClose" mat-button (click)="onNoClick()" tabindex="-1">
  X
</button>
<h1 mat-dialog-title class="title">Security Groups;</h1>
<div class="description">
  Apply security group access to this {{ canvasType }}
  <span *ngIf="!viewMode"
    >- at least one Security Group must have Edit Access at all times</span
  >
</div>

<div mat-dialog-content>
  <table mat-table [dataSource]="dataSource" matSort>
    <!-- Name Column -->
    <ng-container matColumnDef="name">
      <th
        mat-header-cell
        *matHeaderCellDef
        style="text-align: left"
        mat-sort-header
      >
        Security Group
      </th>
      <td mat-cell *matCellDef="let element" style="text-align: left">
        {{ element.name || element.name }}
        <span *ngIf="element.id == userGroupId" class="primary"
          >(Primary Security Group)</span
        >
      </td>
    </ng-container>

    <!-- Weight Column -->
    <ng-container matColumnDef="edit">
      <th mat-header-cell *matHeaderCellDef width="100">Edit Access</th>
      <td mat-cell *matCellDef="let element; let row">
        <mat-checkbox
          (click)="$event.stopPropagation()"
          (change)="toggleEdit(row)"
          [checked]="element.edit"
        >
        </mat-checkbox>
      </td>
    </ng-container>

    <!-- Symbol Column -->
    <ng-container matColumnDef="view">
      <th mat-header-cell *matHeaderCellDef width="100">View Access</th>
      <td mat-cell *matCellDef="let element; let row">
        <mat-checkbox
          (click)="$event.stopPropagation()"
          (change)="toggleView(row)"
          [checked]="element.view"
          [disabled]="viewMode && element.edit"
        >
        </mat-checkbox>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr
      mat-row
      *matRowDef="let row; columns: displayedColumns; let i = index"
      [ngClass]="[row.hide ? 'hidden' : '']"
    ></tr>
  </table>
</div>

<div mat-dialog-actions align="end" style="display: block">
  <button mat-button mat-dialog-close class="button_small cancel">
    cancel
  </button>
  <button
    mat-button
    class="button_small"
    (click)="apply()"
    [disabled]="editItems <= 0"
    *ngIf="!viewMode"
  >
    apply access
  </button>
  <button
    mat-button
    class="button_small"
    (click)="saveAndApply()"
    [disabled]="editItems <= 0"
    *ngIf="viewMode"
  >
    save & apply
  </button>
</div>
